import { createReducer, on } from '@ngrx/store';
import {setProducts, unSetProducts} from './group-view.actions';

export interface State {
    products: Array<any>;
}

export const initialState: State = {
   products: [],
}

const _groupViewReducer = createReducer(initialState,

    on( setProducts,   (state, { items }) => ({ ...state, products: [...items]  })),
    on( unSetProducts, (state) => ({ ...state, products: []}) )
);

export function groupViewReducer(state, action) {
    return _groupViewReducer(state, action);
}
